
<template>
<div>
  <transition name="modal">
    <div class="modal-background" v-if="showing" @click="modalClick">
    </div>
  </transition>
  <transition name="modal">
    <div class="modal-mask" v-if="showing" @click="modalClick">
      <div class="modal-wrapper" ref="mask">
        <div class="modal-container modal">
          <div class="modal-header">
            <h2> {{ title }} </h2>
            <span class="icon far fa-times" aria-hidden="true" @click="hide"></span>
          </div>
          <slot name="body" class="modal-body">
          </slot>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
export default {
  name: 'ChcModal',
  data () {
    return {
      showing: false,
      modified: false
    }
  },
  props: {
    title: {
      default: ''
    }
  },
  methods: {
    show () {
      this.showing = true
    },
    hide () {
      this.showing = false
    },
    modalClick (e) {
      // Only exit if we click outside the content area
      if (e.target === this.$refs.mask && !this.modified) {
        this.showing = false
      }
    },
    modifiedSignal () {
      this.modified = true
    }
  }
}
</script>

<style lang="scss" scoped>

.modal-background {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 9998;
    overflow: hidden;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: opacity .3s ease;
    z-index: 9998;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .0);
    display: table;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: min-content;
    margin: 25px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    max-height: 90vh;
    overflow: scroll;
}

.modal-header {
    vertical-align: middle;
    margin-bottom: 32px;
}

.modal-header h1 {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0px;
}

.modal-body {
  margin: 20px 0;
}

.modal-enter {
  opacity: 0;
}

.close-icon {
    font-size: 24px;
    float: right;
    cursor: pointer;
}

.modal-leave-active {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcModal.vue